import * as React from 'react'
import Seo from '../../components/seo'
import Footer from '../../sections/footer'

import Hero from './components/hero'
import Images from './components/images'

interface IPressAssetsProps {
  match: {
    params: {
      type: string
    }
  }
}

function isType(value: unknown): value is 'logos' | 'office' | 'products' | 'people' {
  return typeof value === 'string' && ['logos', 'office', 'products', 'people'].includes(value)
}

const PressAssets = ({ match }: IPressAssetsProps) => {
  return (
    <>
      <Seo
        description="Här hittar du material att använda för pressinlägg, nyheter och artiklar. "
        image="https://www.dooer.com/images/og/og_index.jpg"
        title="Press & Material | Dooer"
        url="https://www.dooer.com/assets"
      />

      {isType(match.params.type) ? (
        <>
          <Hero type={match.params.type} />
          <Images type={match.params.type} />
        </>
      ) : null}

      <Footer />
    </>
  )
}

export default PressAssets
